// import { ParticipantsData } from '../../../shared/types/participants.types';
import { PillIds } from '../../../shared/types/PillIds';
import { DateRangeSelection } from '@/common/components';
import { Data } from '../../../shared/types/PartnerConsentedParticipantData.types';

export interface ChartsPanelWithMapProps {
  chartData?: Data;
  isLoading?: boolean;
  onCloseModal: () => void;
  onSelectDateRange: (date: DateRangeSelection) => void;
  sectionTitle: string;
  selectedSection: PillIds;
  selectedDateRange?: DateRangeSelection;
  showMapSection?: boolean;
  showModal: boolean;
  goalLine?: number;
}

export enum PillId {
  CONVERSION = 'conversion',
  INTERESTED = 'interested',
}

export enum TabId {
  GRAPH_VIEW = 'graphView',
  MAP_VIEW = 'mapView',
}
